/**
 * Admin · Upcoming bookings card on the Account page.
 * Shows the next 20 confirmed slots formatted in the host timezone.
 */
import { Calendar } from "lucide-react";
import { fmtHostLocal } from "@/lib/timezone";

export default function AdminBookingsCard({ bookings, hostTz }) {
  return (
    <div data-testid="admin-bookings-card" className="mt-10 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6">
      <div className="flex items-center gap-2">
        <Calendar className="h-4 w-4 text-teal-700 dark:text-teal-400" />
        <p className="text-[11px] uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">Admin · Upcoming bookings</p>
      </div>
      <div className="mt-2 flex items-baseline gap-3 flex-wrap">
        <h3 className="font-display text-lg font-semibold text-slate-900 dark:text-slate-50">Next 20 confirmed calls</h3>
        {bookings.length > 0 && (
          <p className="text-sm text-slate-600 dark:text-slate-300">
            <b>{bookings.length}</b> scheduled
          </p>
        )}
      </div>

      {bookings.length === 0 ? (
        <p className="mt-4 text-xs italic text-slate-500 dark:text-slate-400">
          No upcoming bookings. When someone books a slot, it appears here.
        </p>
      ) : (
        <ul className="mt-5 space-y-2" data-testid="admin-bookings-list">
          {bookings.map((b) => (
            <li key={b.id} className="rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900 p-3 flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span className="text-sm font-medium text-slate-900 dark:text-slate-50">{fmtHostLocal(b.slot_start_iso, hostTz)}</span>
              <span className="text-[11px] text-slate-500 dark:text-slate-400">({hostTz})</span>
              <span className="text-sm text-slate-700 dark:text-slate-200">·</span>
              <span className="text-sm text-slate-800 dark:text-slate-100">{b.name}</span>
              <a href={`mailto:${b.email}`} className="text-sm text-teal-700 dark:text-teal-400 hover:underline">{b.email}</a>
              {b.message && <span className="basis-full text-xs text-slate-600 dark:text-slate-300 italic mt-1">&ldquo;{b.message}&rdquo;</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
